var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loadProductPromotion ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showProductPromotion,
      expression: "showProductPromotion"
    }],
    staticClass: "Layer-FullScreen component-nobrand-promotion",
    on: {
      "click": _vm.slideDownProductPromotion
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.productPromotionSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "icon-img"
  }, [_c('div', [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.getPoster(_vm._this);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_img_icon.png"
    }
  }), _c('p', [_vm._v("无品牌海报")])], 1)]), _c('div', [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": _vm.showQRcode
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_QRcode_icon.png"
    }
  }), _c('p', [_vm._v("无品牌二维码")])], 1)]), _c('div', [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": _vm.copyNoBrandLink
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_link_icon.png"
    }
  }), _c('p', [_vm._v("无品牌链接")])], 1)])]), _c('div', {
    staticClass: "btn-cancel",
    on: {
      "click": _vm.slideDownProductPromotion
    }
  }, [_vm._v("取消")])]), _vm.shareLink ? _c('component-nobrand-qrcode') : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };